function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12s12-5.372 12-12c0-6.627-5.373-12-12-12zm7.754 9.561l-8.607 8.607a.448.448 0 0 1-.637 0l-1.272-1.285c-.175-.176-.462-.464-.636-.642l-2.96-3.112a.47.47 0 0 1-.133-.327c0-.115.046-.227.133-.314l1.297-1.169a.447.447 0 0 1 .636 0l2.936 2.995a.447.447 0 0 0 .637 0l6.699-6.681a.447.447 0 0 1 .636 0l1.272 1.285a.458.458 0 0 1-.001.643z" /></svg>;
});